<form class="routed-component-layout" [formGroup]="form" novalidate autocomplete="off">

  <div class="routed-component-body">

    <div class="routed-component-title-block">
      <h2>{{'REGISTRATION.COMPANY_STEP.TRADING_ADDRESS.TITLE' | translate}}</h2>
    </div>
    <div class="callout informative">
      <div class="callout-content">

        <h4>{{'REGISTRATION.COMPANY_STEP.TRADING_ADDRESS.REGISTERED_ADDRESS_TITLE' | translate}}</h4>

        <div class="registered-address-text">

          <div data-cy="line-1">{{registeredAddress.line1}}</div>

          @if (registeredAddress.line2) {
            <div data-cy="line-2">{{registeredAddress.line2}}</div>
          }

          <div class="postcode-city-state">
            @if (registeredAddress.postalCode) {
              <span data-cy="postcode">{{registeredAddress.postalCode}}</span>
            }

            <span data-cy="city">{{registeredAddress.city}}</span>

            @if (registeredAddress.province) {
              <span data-cy="state">{{registeredAddress.province}}</span>
            }
          </div>
        </div>

      </div>
    </div>
    <div class="field-group-layout">
      <h5>{{'REGISTRATION.COMPANY_STEP.TRADING_ADDRESS.QUESTION_SAME_ADDRESS' | translate}}</h5>
      <soldo-field-layout
        [control]="form.controls['tradingAddressDifferent']"
        fieldName="tradingAddressDifferent"
        cypressSelector="Company_RadioButton_SeparateTradingAddress">

        <fieldset input class="horizontal-radio">

            <input id="YES-trading" type="radio" [value]="false"
              formControlName="tradingAddressDifferent" name="tradingAddressDifferent"
              data-cy="Company_RadioButton_SeparateTradingAddress_TRUE">
            <label for="YES-trading">{{ 'REGISTRATION.COMPANY_STEP.TRADING_ADDRESS.YES_ANSWER' | translate }}</label>

            <input id="NO-trading" type="radio" [value]="true"
              formControlName="tradingAddressDifferent" name="tradingAddressDifferent"
              data-cy="Company_RadioButton_SeparateTradingAddress_FALSE">
            <label for="NO-trading">{{ 'REGISTRATION.COMPANY_STEP.TRADING_ADDRESS.NO_ANSWER' | translate }}</label>

        </fieldset>
      </soldo-field-layout>
    </div>
      @if (form.controls.tradingAddress) {
      <div class="field-group-layout">

        <h4>{{'REGISTRATION.COMPANY_STEP.TRADING_ADDRESS.TRADING_ADDRESS_TITLE' | translate}}</h4>

        <address3-form-group
          [addressFormGroup]="form.controls.tradingAddress"
          [activeMarketsOnly]="onlyActiveMarket === false"
          [translatedCountries]="translatedCountries"
          data-cy="Company_Address_TradingAddress"/>

      </div>
      }
  </div>

  <!-- Sub-Step Navigation -->
  <div class="navigation-controls-layout">

    <div class="routed-component-cta">
      <button type="button" (click)="previousStep()" [disabled]="loading" data-cy="Signup_Button_PreviousStepButton">
        {{ 'REGISTRATION.COMPANY_STEP.PREVIOUS_SUB_STEP_BUTTON' | translate }}
      </button>

      <button type="submit" class="primary" (click)="nextStep()" [disabled]="loading"
        [ngClass]="{ 'loading': loading}" data-cy="Signup_Button_NextStepButton">
        {{ 'REGISTRATION.COMPANY_STEP.NEXT_SUB_STEP_BUTTON' | translate}}
      </button>
    </div>

    <save-and-continue-later stepName="Company Trading Address"></save-and-continue-later>
  </div>

</form>

